import { Element } from './Element'

export class Header {
  id: string
  elements: Element[]

  constructor() {
    this.id = ''
    this.elements = new Array()
  }
}
